import { useState } from "react";
import { Search, Menu } from "lucide-react";
import { FaHeart } from "react-icons/fa";
import { useTranslation } from "context/LanguageContext";
import SlideMenu from "shared/components/layout/SlideMenu";
import CartSidebar from "shared/components/cart/CartSidebar";
import { useCart } from "context/CartContext";
import { useNavigate } from "react-router-dom";
import CartButton from "shared/components/cart/CartButton";
import { getCurrentClientConfig } from "config/clientConfig";

export default function Navbar() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isCartOpen, setIsCartOpen] = useState(false);
  const { t } = useTranslation();

  const { getCartCount } = useCart();
  const cartCount = getCartCount();
  const navigate = useNavigate();

  const handleSearchClick = () => {
    navigate("/search");
  };

  return (
    <>
      <nav className="bg-white shadow-md relative z-40">
        <div className="max-w-7xl mx-auto px-4 py-4">
          {/* Desktop */}
          <div className="hidden lg:flex items-center justify-between">
            <button
              onClick={() => setIsMenuOpen(true)}
              className="p-2 hover:bg-gray-100 rounded-lg transition"
            >
              <Menu className="w-6 h-6 text-blue-600" />
            </button>

            <div className="flex-1 max-w-xl mx-8"></div>

            <div className="flex items-center gap-6">
              <button
                onClick={handleSearchClick}
                className="hover:opacity-80 transition text-center"
              >
                <Search className="w-6 h-6 text-blue-600 mx-auto" />
                <span className="text-sm text-gray-700">{t("search")}</span>
              </button>

              <button className="hover:opacity-80 transition text-center">
                <FaHeart className="w-6 h-6 text-blue-600 mx-auto" />
                <span className="text-sm text-gray-700">{t("favorites")}</span>
              </button>

              <CartButton
                cartCount={cartCount}
                cartStatus={setIsCartOpen}
                setHide={false}
              />
            </div>
          </div>

          {/* Mobile */}
          <div className="lg:hidden flex justify-between items-center">
            <button
              onClick={() => setIsMenuOpen(true)}
              className="p-2 hover:bg-gray-100 rounded-lg transition"
            >
              <Menu className="w-6 h-6 text-blue-600" />
            </button>

            <div>{getCurrentClientConfig().brandName}</div>

            <div className="flex items-center gap-3">
              <button onClick={handleSearchClick}>
                <Search className="w-6 h-6 text-blue-600" />
              </button>

              <CartButton
                cartCount={cartCount}
                cartStatus={setIsCartOpen}
                setHide={true}
              />
            </div>
          </div>
        </div>
      </nav>

      {/* Slide Menu */}
      <SlideMenu isOpen={isMenuOpen} onClose={() => setIsMenuOpen(false)} />

      {/* Cart Sidebar */}
      <CartSidebar isOpen={isCartOpen} onClose={() => setIsCartOpen(false)} />
    </>
  );
}
